import AbstractBlock from './abstractBlock.js';

export default class LoaderBlock extends AbstractBlock {
    /**
     * Инициализируем поведение
     *
     * @param {jquery} element
     */
    init(element) {
        this.element = element.find('.js-enter_info_loader');
        this.textElement = this.element.find('.js-enter_info_loader__text');
        if (this.hasElement) {
            console.log('Loader Block inited');
        } else {
            console.warn('Loader Block no element');
        }
    }

    /**
     * Установить текст экрана загрузки
     * @param  {String} value
     */
    set text(value) {
        this.textElement.html(value);
    }
}
